// extracted by mini-css-extract-plugin
export default {"container":"DeliveryPage_container__4JOSe"};